import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Rx';

import { Institution } from '../../datamodel/institution';

@Component({selector: 'app-root', templateUrl: './hospitals.component.html', styleUrls: ['./hospitals.component.scss']})
export class HospitalsComponent implements OnInit {
    private institutionsCollection : AngularFirestoreCollection < Institution >;
    institutions : Observable < Institution[] >;

    private locationCache = {};

    constructor(private afs : AngularFirestore) {
        this.institutionsCollection = afs.collection <Institution> ('institutions');
        this.institutions = this.institutionsCollection.valueChanges();
        console.log(this.institutions);
    }
    
    public stringify = JSON.stringify

    ngOnInit() {}

}


// WEBPACK FOOTER //
// ./src/app/modules/superadmin/hospitals/hospitals.component.ts